import {http} from '@/helpers/http-helper';

class FeeType {
    constructor(
        uuid,
        name,
        amount,
        periodicity,
        active,
        createdAt,
        updatedAt
    ) {
        this.uuid = uuid;
        this.name = name;
        this.amount = amount;
        this.periodicity = periodicity;
        this.active = active;
        this.createdAt = createdAt;
        this.updatedAt = updatedAt;
    }
}

export const getFeeTypes = () => {
    return new Promise((resolve, reject) => {
        const url = 'fee/types';
        http.get(url)
            .then((response) => {
                if (response.status === 200) {
                    let feeTypes = [];
                    response.data.forEach((feeType) => {
                        feeTypes.push(new FeeType(
                            feeType.uuid,
                            feeType.name,
                            feeType.amount,
                            feeType.periodicity,
                            feeType.active,
                            new Date(feeType.createdAt),
                            new Date(feeType.updatedAt)
                        ));
                    });

                    resolve(feeTypes);
                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const createFeeType = (feeType) => {
    return new Promise((resolve, reject) => {
        const url = 'fee/types';
        http.post(url, feeType)
            .then((response) => {
                if (response.status === 201) {
                    resolve(response.data);
                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const updateFeeType = (feeTypeId, feeType) => {
    return new Promise((resolve, reject) => {
        const url = 'fee/types/'+ feeTypeId;
        http.post(url, feeType)
            .then((response) => {
                if (response.status === 200) {
                    resolve(new FeeType(
                        response.data.uuid,
                        response.data.name,
                        response.data.amount,
                        response.data.periodicity,
                        response.data.active,
                        new Date(response.data.createdAt),
                        new Date(response.data.updatedAt)
                    ));
                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const deleteFeeType = (feeTypeId) => {
    return new Promise((resolve, reject) => {
        const url = 'fee/types/' + feeTypeId;
        http.delete(url)
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};